import { RouteObject } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HomePage from "@/pages/home/page";
import ServicesPage from "@/pages/services/page";
import ServiceDetailPage from "@/pages/services/ServiceDetailPage";
import AboutPage from "@/pages/about/page";
import TestimonialsPage from "@/pages/testimonials/page";
import ContactPage from "@/pages/contact/page";
import CookiePolicyPage from "@/pages/legal/CookiePolicyPage";
import AccessibilityPage from "@/pages/legal/AccessibilityPage";
import PrivacyPolicyPage from "@/pages/legal/PrivacyPolicyPage";
import TermsPage from "@/pages/legal/TermsPage";
import NotFound from "@/pages/NotFound";

const HomeWithLayout = () => (
  <>
    <Navbar />
    <HomePage />
    <Footer />
  </>
);

const routes: RouteObject[] = [
  { path: "/", element: <HomeWithLayout /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/services/:slug", element: <ServiceDetailPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/testimonials", element: <TestimonialsPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/cookie-policy", element: <CookiePolicyPage /> },
  { path: "/accessibility", element: <AccessibilityPage /> },
  { path: "/privacy-policy", element: <PrivacyPolicyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
